export default "__VITE_ASSET__847a8430__"